import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=6cedf81d&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cedf81d')) {
      api.createRecord('6cedf81d', component.options)
    } else {
      api.reload('6cedf81d', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=6cedf81d&", function () {
      api.rerender('6cedf81d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ui3bmJD7PLiK/JS/imageCarousel.vue"
export default component.exports